import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120'),
	() => import('./nodes/121'),
	() => import('./nodes/122'),
	() => import('./nodes/123'),
	() => import('./nodes/124'),
	() => import('./nodes/125')
];

export const server_loads = [];

export const dictionary = {
		"/": [30],
		"/about-us": [83],
		"/affiliate": [84,[20]],
		"/aml-policy": [85],
		"/betfeed": [86],
		"/blog": [87],
		"/bonus-terms": [88],
		"/calendar": [89],
		"/casino": [90],
		"/complaints-and-arbitration": [91],
		"/contact": [92],
		"/fairness": [93],
		"/faq": [94],
		"/faq/[section]": [95],
		"/game/[game]": [96,[21]],
		"/in": [97],
		"/in/[actionSlug]": [98],
		"/kyc-policy": [99],
		"/leaderboard": [100],
		"/originals": [101],
		"/originals/[game]": [102,[22]],
		"/payment-policy": [105],
		"/privacy-policy": [106],
		"/promotion-page": [107],
		"/promotion-page/race/[...id]": [109,[26]],
		"/promotion-page/[...id]": [108,[25]],
		"/providers": [110],
		"/p/[provider]": [103,[23]],
		"/p/[provider]/[game]": [104,[23,24]],
		"/races/current": [112],
		"/races/last": [113],
		"/races/next": [114],
		"/races/[raceId]": [111],
		"/referral": [115],
		"/responsible-gaming": [116],
		"/(call-request)/sizi-arayalim": [31,[2]],
		"/special-bets": [118],
		"/special": [117,[27]],
		"/sports": [119,[28]],
		"/sports/[...slug]": [120,[28,29]],
		"/terms-of-service": [121],
		"/terms-sports": [122],
		"/tournaments": [123],
		"/transparency": [124],
		"/vip": [125],
		"/[provider=provider]": [81,[18]],
		"/[lang=lang]": [34,[4]],
		"/[category=category]": [33,[3]],
		"/[lang=lang]/about-us": [40,[4]],
		"/[lang=lang]/affiliate": [41,[4,9]],
		"/[lang=lang]/aml-policy": [42,[4]],
		"/[lang=lang]/betfeed": [43,[4]],
		"/[lang=lang]/blog": [44,[4]],
		"/[lang=lang]/bonus-terms": [45,[4]],
		"/[lang=lang]/calendar": [46,[4]],
		"/[lang=lang]/casino": [47,[4]],
		"/[lang=lang]/complaints-and-arbitration": [48,[4]],
		"/[lang=lang]/contact": [49,[4]],
		"/[lang=lang]/fairness": [50,[4]],
		"/[lang=lang]/faq": [51,[4]],
		"/[lang=lang]/faq/[section]": [52,[4]],
		"/[lang=lang]/game/[game]": [53,[4,10]],
		"/[lang=lang]/kyc-policy": [54,[4]],
		"/[lang=lang]/leaderboard": [55,[4]],
		"/[lang=lang]/originals": [56,[4]],
		"/[lang=lang]/originals/[game]": [57,[4,11]],
		"/[lang=lang]/payment-policy": [60,[4]],
		"/[lang=lang]/privacy-policy": [61,[4]],
		"/[lang=lang]/promotion-page": [62,[4]],
		"/[lang=lang]/promotion-page/race/[...id]": [64,[4,15]],
		"/[lang=lang]/promotion-page/[...id]": [63,[4,14]],
		"/[lang=lang]/providers": [65,[4]],
		"/[lang=lang]/p/[provider]": [58,[4,12]],
		"/[lang=lang]/p/[provider]/[game]": [59,[4,12,13]],
		"/[lang=lang]/races/current": [67,[4]],
		"/[lang=lang]/races/last": [68,[4]],
		"/[lang=lang]/races/next": [69,[4]],
		"/[lang=lang]/races/[raceId]": [66,[4]],
		"/[lang=lang]/referral": [70,[4]],
		"/[lang=lang]/responsible-gaming": [71,[4]],
		"/[lang=lang]/(call-request)/sizi-arayalim": [35,[4,5]],
		"/[lang=lang]/special-bets": [73,[4]],
		"/[lang=lang]/special": [72,[4,16]],
		"/[lang=lang]/sports": [74,[4]],
		"/[lang=lang]/sports/[...slug]": [75,[4,17]],
		"/[lang=lang]/terms-of-service": [76,[4]],
		"/[lang=lang]/terms-sports": [77,[4]],
		"/[lang=lang]/tournaments": [78,[4]],
		"/[lang=lang]/transparency": [79,[4]],
		"/[lang=lang]/vip": [80,[4]],
		"/[lang=lang]/[provider=provider]": [38,[4,7]],
		"/[lang=lang]/[category=category]": [37,[4,6]],
		"/[lang=lang]/[provider=provider]/[game]": [39,[4,7,8]],
		"/[provider=provider]/[game]": [82,[18,19]],
		"/[lang=lang]/[...fallback]": [36,[4]],
		"/[...fallback]": [32]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';